/*******************************************************************************
 * Copyright (c) 2019. BMW Group. All rights reserved.
 ******************************************************************************/

import {Component, Input, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {WarningsEnum} from '../warnings.enum';

@Component({
    selector: 'app-warning-box',
    templateUrl: './warning-box.component.html',
    styleUrls: ['./warning-box.component.css', '../warnings.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class WarningBoxComponent implements OnInit {

    @Input() warningLevel: WarningsEnum;

    constructor() {
    }

    get warningIconClass(): string {
        switch (this.warningLevel) {
            case WarningsEnum.ERROR:
                return 'iwp-icon-gen_info_error';
                break;
            case WarningsEnum.INFO:
                return 'iwp-icon-gen_info_info';
                break;
            case WarningsEnum.WARNING:
                return 'iwp-icon-gen_info_warning';
                break;
            default:
                return 'iwp-icon-gen_info_error';
        }
    }

    get warningBoxClass(): string {
        switch (this.warningLevel) {
            case WarningsEnum.ERROR:
                return 'error';
                break;
            case WarningsEnum.INFO:
                return 'info';
                break;
            case WarningsEnum.WARNING:
                return 'warning';
                break;
            default:
                return 'error';
        }
    }

    ngOnInit(): void {
    }

}
